import { render, staticRenderFns } from "./ConfirmDeleteInvitationProvider.vue?vue&type=template&id=1e104982&scoped=true&"
import script from "./ConfirmDeleteInvitationProvider.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeleteInvitationProvider.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmDeleteInvitationProvider.vue?vue&type=style&index=0&id=1e104982&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e104982",
  null
  
)

export default component.exports